export default __webpack_public_path__ + "static/media/banner3.2354f795.jpg";